import { render, staticRenderFns } from "./PassengersMarketing.vue?vue&type=template&id=1bc5dcad&scoped=true"
import script from "./PassengersMarketing.vue?vue&type=script&lang=js"
export * from "./PassengersMarketing.vue?vue&type=script&lang=js"
import style0 from "./PassengersMarketing.vue?vue&type=style&index=0&id=1bc5dcad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5dcad",
  null
  
)

export default component.exports